/**
 * Stripe Account Status Constants
 */
export const STRIPE_ACCOUNT_STATUS = {
    ACTIVE: 'active',
    PENDING_VERIFICATION: 'pending-verification',
    RESTRICTED: 'restricted',
    RESTRICTED_SOON: 'restricted-soon',
    REJECTED: 'rejected',
    REJECTED_APPEAL_SUBMITTED: 'rejected-appeal-submitted',
} as const;

export type StripeAccountStatus = (typeof STRIPE_ACCOUNT_STATUS)[keyof typeof STRIPE_ACCOUNT_STATUS];
